import {Component} from '@angular/core'
import {RouterOutlet} from '@angular/router'

@Component({
  selector: 'smt-root',
  template: '<router-outlet id="i"/>',
  imports: [
    RouterOutlet
  ],
})
export class App {
}
